import clsx from "clsx";
import React, { ReactNode } from "react";

interface WrapperProps {
  children: ReactNode;
  className?: string;
  fullWidth?: boolean;
}

const Wrapper: React.FC<WrapperProps> = ({
  children,
  className,
  fullWidth,
}) => {
  return (
    <section
      className={clsx(
        { "max-w-7xl": !fullWidth },
        "mx-auto",
        "px-2",
        "md:px-4",
        "lg:px-8",
        ...(className ? [className] : [])
      )}
    >
      {children}
    </section>
  );
};

export default Wrapper;
